import { createValidator } from '../../validation';

import {
  clubPremierNumber,
  checkNewPasswordValidations,
  confirmPasswordValidation,
} from './user-profile-account-validator';

const userProfileAccountValidationFields = {
  clubPremierNumber: [clubPremierNumber],
  confirmPassword: [confirmPasswordValidation],
  newPassword: [checkNewPasswordValidations],
};

const userProfileAccountValidator = createValidator(userProfileAccountValidationFields);

const userProfileAccountValidation = values => {
  return userProfileAccountValidator(values);
};

export default userProfileAccountValidation;
